import type { FC } from 'react';
import type { ThreeColumnProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import style from './ThreeColumn.module.scss';
import RichText from '../RichText';
import { useColorProvider } from '@/utils/ColorProvider';
const ThreeColumn: FC<Props> = ({
  extendStyles,
  heading,
  copy,
  cardStyling,
  alignCenter,
  columns,
  children,
  backgroundColor,
  lockImageSize,
  circularImages,
  lowerCopy
}) => {
  const _className = cls(style.root, extendStyles, (!!cardStyling || !!alignCenter) && style.center);
  const colStyles = cls(style.wrapper, !!cardStyling && style.cards);
  const {
    colors
  } = useColorProvider();
  return <section className={_className} style={{
    backgroundColor
  }} data-sentry-component="ThreeColumn" data-sentry-source-file="ThreeColumn.tsx">
			<div className={style.content}>
				{!!heading && <RichText text={heading || ''} />}
				{!!copy && <RichText text={copy || ''} />}
				<div className={colStyles} style={{
        borderColor: colors.secondaryAccentColor || 'transparent',
        marginBottom: 0
      }} data-testid="three-column">
					{columns.map((col, i) => {
          const paddingClass = cls(style.column, !!col.image ? '' : style.altPadding, lockImageSize && style.lockImage, circularImages && style.circularImage);
          return <div key={`column-${i}`} className={paddingClass} style={{
            backgroundColor: cardStyling ? 'white' : backgroundColor
          }}>
								{col.image && <div className={style.imageContainer}>
										<img src={col.image} alt="" role="presentation" />
									</div>}
								<div className={style.columnContent}>
									{!!col.columnHeading && <RichText text={col.columnHeading} className={col.horizontalRule ? style.hr : ''} style={{
                borderColor: col.hrColor
              }} />}
									{!!col.columnCopy && <RichText text={col.columnCopy} />}
								</div>
							</div>;
        })}
				</div>
				{!!lowerCopy && <RichText text={lowerCopy} />}
				{children}
			</div>
		</section>;
};
export default withChildren(ThreeColumn);